@let isMobile = responsive.isMobile$ | async;

<nz-row nzAlign="middle" nzJustify="space-between">
  <nz-col>
    @if (!hideLogo() || isMobile) {
      <div class="logo">
        <img src="assets/mathema-logo-3.png" alt="Logo" />
      </div>
    }
  </nz-col>

  <nz-col>
    <math-language-switch />
  </nz-col>
</nz-row>
